import type { ReactNode } from 'react';
import { Stack } from '../primitives/Stack.js';
import { Text } from '../primitives/Text.js';
import { StateIllustration, type StateIllustrationVariant } from './StateIllustration.js';
import styles from './StatusPage.module.css';

export type StatusPageProps = {
  variant: StateIllustrationVariant;
  title: string;
  description?: ReactNode;
  children?: ReactNode;
  illustrationSize?: 'sm' | 'md' | 'lg';
  /** Muted sage/feldspar treatment (default on status pages). */
  illustrationTone?: 'soft' | 'default';
  className?: string;
};

/** Centered status shell (errors, 404, empty) with unDraw illustration. */
export function StatusPage({
  variant,
  title,
  description,
  children,
  illustrationSize = 'sm',
  illustrationTone = 'soft',
  className,
}: StatusPageProps) {
  return (
    <div className={className ? `${styles.root} ${className}` : styles.root}>
      <Stack gap="md" className={styles.panel}>
        <div className={styles.illustrationWrap}>
          <StateIllustration variant={variant} size={illustrationSize} tone={illustrationTone} />
        </div>
        <Text component="p" size="lg" fw={600}>
          {title}
        </Text>
        {description ? (
          typeof description === 'string' ? (
            <Text c="muted">{description}</Text>
          ) : (
            description
          )
        ) : null}
        {children ? <div className={styles.actions}>{children}</div> : null}
      </Stack>
    </div>
  );
}
